/* Hamak i Ja — article page helpers (sections/main-article.liquid):
   table of contents always open on desktop / collapsed on mobile, reading-progress bar, copy-link status. */
(() => {
  const mq = window.matchMedia('(min-width: 990px)');

  const initToc = (details) => {
    const apply = () => {
      details.open = mq.matches ? true : details.dataset.hkUserOpen === 'true';
    };
    details.querySelector('summary')?.addEventListener('click', (e) => {
      if (mq.matches) {
        e.preventDefault();
        return;
      }
      details.dataset.hkUserOpen = details.open ? 'false' : 'true';
    });
    // jump links close the mobile TOC
    details.addEventListener('click', (e) => {
      if (!mq.matches && e.target.closest('a[href^="#"]')) {
        details.open = false;
        details.dataset.hkUserOpen = 'false';
      }
    });
    mq.addEventListener?.('change', apply);
    apply();
  };

  const initProgress = (bar) => {
    const toc = bar.closest('hk-toc');
    const body = toc && document.querySelector(toc.dataset.source);
    if (!body) return;
    let raf = null;
    const update = () => {
      raf = null;
      const r = body.getBoundingClientRect();
      const total = r.height - window.innerHeight * 0.4;
      const done = window.innerHeight * 0.6 - r.top;
      const pct = Math.max(0, Math.min(100, total > 0 ? (done / total) * 100 : 100));
      bar.style.setProperty('--hk-read', `${pct.toFixed(1)}%`);
      bar.setAttribute('aria-valuenow', String(Math.round(pct)));
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-hk-toc-details]').forEach(initToc);
    root.querySelectorAll('[data-hk-progress]').forEach((bar) => {
      const span = bar.querySelector('span');
      if (span) span.style.width = 'var(--hk-read, 0%)';
      initProgress(bar);
    });
  };

  // announce "Skopiowano link" for screen readers (the visual state comes from hk-base.js)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.hk-ashare [data-hk-copy]');
    if (!btn) return;
    const status = btn.closest('.hk-ashare').querySelector('[data-hk-copy-status]');
    if (status) {
      status.textContent = '';
      window.setTimeout(() => { status.textContent = btn.dataset.hkCopied || ''; }, 50);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
